"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SkipToContent_component_exports = {};
__export(SkipToContent_component_exports, {
  SkipToContent: () => SkipToContent,
  default: () => SkipToContent_component_default
});
module.exports = __toCommonJS(SkipToContent_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_Button = require("../../Button/Button.component");
const SkipToContent = ({ targetId, text }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_Button.Button,
    {
      variant: "secondary",
      as: "a",
      href: `${targetId}`,
      className: `absolute left-[-170px] top-[-20px] transition-transform duration-300 focus:left-20 focus:top-5`,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Label, { children: text })
    }
  );
};
var SkipToContent_component_default = SkipToContent;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SkipToContent
});
//# sourceMappingURL=SkipToContent.component.js.map